/*
 * Twitter Bootstrap 4 plugin for AngularJS.
 * Copyright (c) 2016-2021 Rodziu <mateusz.rohde@gmail.com>
 * License: MIT
 */
/**
 * @ngInject
 */
export class BsCollapseGroupDirectiveController {
    constructor() {
        this.children = [];
    }
    register(bsCollapseCtrl) {
        this.children.push(bsCollapseCtrl);
    }
    unregister(bsCollapseCtrl) {
        this.children.splice(this.children.indexOf(bsCollapseCtrl), 1);
    }
    expand(invokingCtrl) {
        for (let c = 0; c < this.children.length; c++) {
            if (this.children[c] !== invokingCtrl) {
                this.children[c].bsCollapse = true;
            }
        }
    }
}
export function bsCollapseGroupDirective() {
    return {
        restrict: 'A',
        controller: BsCollapseGroupDirectiveController
    };
}
